import React, { useEffect, useState } from 'react';
import { Col, Modal, Row, Tabs, Card } from 'antd';
import { Form } from 'antd';
import IUpdate from 'icons/IUpdate';
import IAdd from 'icons/IAdd';
import FormInput from 'components/FormInput';
import ParListSelect from 'components/ParListSelect';
import ButtonOperation from 'components/ButtonOperation';
import Bank from 'components/Bank';
import { useForm } from 'antd/lib/form/Form';
export type BankAccountsListModalProps = {
  tpid: number;
  record?: any;
  onClose?: any;
  visible: boolean;
  updateAddress?: boolean;
  onSave: (add: any) => void;
  initadd: any;
  showAsModal?: boolean;
  countcode: string;
  currcode: string;
};

const BankAccountsListModal = (props: BankAccountsListModalProps) => {
  const {
    onClose,
    onSave,
    initadd,
    visible = false,
    record,
    countcode,
    currcode,
    showAsModal,
  } = props;

  const [form] = useForm();

  const [state, setstate] = useState<any>({
    record: initadd,
  });

  const reset = () => {
    setstate({ ...state, record: initadd });
  };

  useEffect(() => {
    if (record) {
      form.setFieldsValue({
        tpbkid: record.tpbkid,
        bkaccountkey: record.bkaccountkey,
        bkaccountnum: record.bkaccountnum,
        bkbranchcode: record.bkbranchcode,
        bkcode: record.bkcode,
        bktype:record.bktype,
        currcode:record.currcode,
        tpbic:record.tpbic,
        tpiban:record.tpiban,
        tpbankname:record.tpbankname,
        tpcbtype:record.tpcbtype
      });
    } else {
      form.setFieldsValue(initadd);
    }
  }, [form, record, initadd]);

  return (
    <Modal
      visible={visible}
      title={record ? 'Update Bank Account' : 'Add Bank Account'}
      width="1200px"
      style={{ top: 100 }}
      footer={null}
      destroyOnClose
      onCancel={() => {
        onClose();
        setstate({ record: initadd });
        reset();
      }}
    >
      <Form
        form={form}
        onFinish={(e) => {
          e = {
            ...e,
            tpbkid: form.getFieldValue('tpbkid'),
            bkaccountkey: form.getFieldValue('bkaccountkey'),
            bkaccountnum: form.getFieldValue('bkaccountnum'),
            bkbranchcode: form.getFieldValue('bkbranchcode'),
            bkcode: form.getFieldValue('bkcode'),
          };

          onSave(e);
          setstate({ record: initadd });
          //   onClose();
        }}
      >
        <Tabs
          type="card"
          tabBarExtraContent={
            !showAsModal && (
              <Row gutter={16}>
                <Col>
                  <ButtonOperation comcode="Cancel" onClick={onClose} />
                </Col>
                <Col>
                  <ButtonOperation
                    icon={record ? <IUpdate></IUpdate> : <IAdd></IAdd>}
                    comcode={record ? 'Update' : 'Add'}
                    htmlType="submit"
                  />
                </Col>
              </Row>
            )
          }
        ></Tabs>

        <Card bordered>
          <Row gutter={16}>
            <FormInput 
             col 
             xs={12} 
             name="bktype"
             labelCol={{span:5}}
            >
              <ParListSelect
                parcode="PAYDIR"
                disabled={record || showAsModal}
              />
            </FormInput>
            <FormInput 
              col 
              xs={6} 
              name="currcode"
              labelCol={{span:10}}
            >
              <ParListSelect parcode="CURRENCY" />
            </FormInput>
            <Bank
              form={form}
              countcode={countcode}
              currcode={currcode}
              colU={12}
              bankField="bkcode"
              branchField="bkbranchcode"
              cbkeyField="bkaccountkey"
              cbnumField="bkaccountnum"
              ibanField="tpiban"
              bicField="tpbic"
              banknameField="tpbankname"
            />
          </Row>
        </Card>
      </Form>
    </Modal>
  );
};

export default BankAccountsListModal;
